export default __webpack_public_path__ + "static/media/Layer 15.6d890695.png";